export default function resizeTableHeader(api, height) {
  const parentElm = api.gridCore.eGridDiv.offsetParent;
  const { parentHeight, headerHeight } = height;
  const totalHeight = parentHeight + headerHeight;
  const eBodyHeight = api.gridPanel.eBody.style.height.replace('px', '');

  // TODO: refactor this to not use forEach
  [].forEach.call(
    parentElm.querySelectorAll('.ag-header-row:first-child'),
    (row) => row.style.height = `${parentHeight}px`
  );

  // Set height and top on 2nd row below parent row
  [].forEach.call(
    parentElm.querySelectorAll('.ag-header-row:last-child'),
    (row) => {
      row.style.height = `${headerHeight}px`;
      row.style.top = `${parentHeight}px`;
    }
  );

  api.gridPanel.eHeader.style.height = `${totalHeight}px`;
  api.gridPanel.eBody.style.top = `${totalHeight}px`;
  api.gridPanel.eBody.style.height =
  `${eBodyHeight + (headerHeight - parentHeight)}px`;
}



// WEBPACK FOOTER //
// ./app/services/resizeTableHeader.js